import './i18n'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './pages/App'
import reportWebVitals from './reportWebVitals'
import { CssBaseline, ThemeProvider } from '@mui/material'
import theme from './theme'
import { init_sentry } from './sentryConfig'
import { getEnvironment } from './utils/environment'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import PasswordSetupStep from './pages/PasswordSetup'
import RouteErrorBoundary from './pages/RouteErrorBoundary'
import Signup from './pages/Signup'
import SignupComplete from './pages/SignupComplete'
import { ConsoleManager } from './services/console/ConsoleManager'
import { initChunkErrorListener } from './services/error/ChunkErrorListener'
import { initTranslationCrashGuard } from './services/error/TranslationCrashGuard'

initChunkErrorListener()
initTranslationCrashGuard()

const environment = getEnvironment()
console.info('Environment: ' + environment)

if (environment === 'production') {
    ConsoleManager.getInstance().disableLogging()
}

init_sentry(environment)

// Data router (instead of <BrowserRouter>) so useBlocker can guard route changes while recording
const router = createBrowserRouter([
    {
        errorElement: <RouteErrorBoundary />,
        children: [
            { path: '/password-setup', element: <PasswordSetupStep /> },
            { path: '/signup', element: <Signup /> },
            { path: '/signup/complete', element: <SignupComplete /> },
            { path: '/*', element: <App /> },
        ],
    },
])

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <RouterProvider router={router} />
    </ThemeProvider>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.info))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
